<script>
	import MediaQuery, { breakpoint, platform, orientation } from "./components/MediaQuerySsr.svelte";

	import Sankey from "./components/Sankey/Sankey.svelte";
	import NodeLabel from "./components/NodeLabel.svelte";
	import LinkLabel from "./components/LinkLabel.svelte";

	import { formatFloat, formatMoneyFloatB } from "./utils";

	import data from "./data/sankey.json";

	// ///////////////////////////////////////////////////////////
	// props
	// ///////////////////////////////////////////////////////////
	export let name;
	export let paywall;

	const getIdFromStr = (str) => str.substring(str.indexOf("_") + 1);
	data.links.forEach((d) => {
		d.id = d.source + "_" + d.target;
	});

	data.nodes.forEach((d) => {
		d.region = getIdFromStr(d.id);
		d.type = d.id.includes("source") ? "source" : d.id.includes("target") ? "target" : undefined;

		const links = data.links.filter((link) => link[d.type] === d.id && link.value > 0);
		const gdpID = d.type + "GDP";
		d.gdpPercentage = links.reduce((acc, curr) => acc + curr[gdpID], 0);
		if (d.type === "source") {
			d.gdpPercentage = -d.gdpPercentage;
		}
	});

	const frmt = formatMoneyFloatB({ digits: 0, currency: "$" });
	const frmtGDP = formatFloat({ digits: 1, prefix: "BIP ", postfix: "%", signed: true });

	const colors = {
		north_america: "#FFAB2C",
		europe: "#FFAB2C",
		oceania: "#FFAB2C",
		south_america: "#5DC0CD",
		asia: "#9868FF",
		africa: "#FF6363",
	};

	const padding = {
		desktop: {
			left: 88,
			right: 82,
		},
		tablet: {
			left: 78,
			right: 73,
		},
		mobile: {
			left: 66,
			right: 62,
		},
	};
	// ///////////////////////////////////////////////////////////
	// sort links and nodes based on a list, e.g. the sortList below
	// ///////////////////////////////////////////////////////////
	const sortList = ["europe", "north_america", "asia", "oceania", "africa", "south_america"];

	const linkSort = (a, b) => {
		const aSource = a.source.region;
		const bSource = b.source.region;
		const aTarget = a.target.region;
		const bTarget = b.target.region;

		const aSourceIndex = sortList.indexOf(aSource);
		const bSourceIndex = sortList.indexOf(bSource);
		const aTargetIndex = sortList.indexOf(aTarget);
		const bTargetIndex = sortList.indexOf(bTarget);

		const aIndex = aSourceIndex + aTargetIndex;
		const bIndex = bSourceIndex + bTargetIndex;

		return aIndex - bIndex;
	};
</script>

<MediaQuery />
<div class="climate-sankey">
	<div class="arrow-container">
		<span class="arrow-text">Verlierer</span>
		<div class="arrow-line"></div>
		<div class="arrow-head"></div>
		<span class="arrow-text">Gewinner</span>
	</div>
	<Sankey
		{data}
		colorNodes={(d) => colors[d.region]}
		colorLinks={"gradient"}
		nodeWidth={3.5}
		nodePadding={2}
		{linkSort}
		padding={{
			left: padding[$platform || "desktop"].left,
			right: padding[$platform || "desktop"].right,
			bottom: 5,
		}}
	>
		<div class="node-label" slot="node_label" let:node let:type let:highlighted>
			<NodeLabel {node} {type} {highlighted} color={colors[node.region]} formatValue={frmt} formatGDP={frmtGDP} />
		</div>
		<div class="link-label" slot="link_label" let:link let:highlighted>
			<LinkLabel {link} {highlighted} formatValue={frmt} />
		</div>
	</Sankey>
</div>

<style lang="scss">
	.climate-sankey {
	}

	.node-label,
	.link-label {
		position: relative;
	}

	.arrow-container {
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 400px;
		margin: 0 auto 20px auto;

		.arrow-line {
			height: 1px;
			background-color: $gray;
			flex-grow: 1;
			margin-left: 15px;
		}

		.arrow-text {
			color: $gray;
			font-weight: $medium;
			letter-spacing: 1.12px;
			text-transform: uppercase;
		}
		.arrow-head {
			display: inline-block;
			width: 0;
			height: 0;
			border-top: 5px solid transparent;
			border-bottom: 5px solid transparent;
			border-left: 7px solid $gray;
			margin-right: 15px;
		}
	}
</style>
